import { DialogContent as MuiDialogContent, DialogContentProps } from '@mildang/mui';
import { css, cx } from '@mildang/styled-system/css';
import { SystemStyleObject } from '@mildang/styled-system/types';
import { splitCssProps } from '@mildang/styled-system/jsx';

const rootStyle = css({
  display: 'flex',
  flexDirection: 'column',
});

export interface DialogBodyProps extends DialogContentProps {
  panda?: SystemStyleObject;
}

const DialogBody = (props: DialogBodyProps) => {
  const { children, panda, className, ...others } = props;
  const [cssProps] = splitCssProps(others);
  const { ...styleProps } = cssProps;

  return (
    <MuiDialogContent className={cx(rootStyle, css(styleProps, panda), className)} {...others}>
      {children}
    </MuiDialogContent>
  );
};

export default DialogBody;
